__turbopack_context__.v({
  "list": "basket-list-module-scss-module__LamkNq__list",
});
